export const formatString = (
  text: string,
  values: { [key: string]: string }
): string =>
  Object.keys(values).reduce((acc, key) => {
    const symbol = `{{${key}}}`

    return acc.replace(new RegExp(symbol, 'g'), values[key])
  }, text)
